import axios from 'axios';

export const fetchEmployerData = async (employerName) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}public401k/data/${employerName}`;
  const response = await axios.get(url);
  return response.data;
};
